import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch PageVariableMap data
export const fetchPageVariableMapData = createAsyncThunk(
  "pageVariableMap/fetchPageVariableMapData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/panel/pagePanelMap"); 
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update PageVariableMap data
export const updatePageVariableMapData = createAsyncThunk(
  "pageVariableMap/updatePageVariableMapData",
  async (pageVariableMapData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/panel/pagePanelMap", pageVariableMapData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Add new PageVariableMap data
export const addPageVariableMapData = createAsyncThunk(
  "pageVariableMap/addPageVariableMapData",
  async (newPageVariableMapData, { rejectWithValue }) => {
    try {
      const response = await api.post("/panel/pagePanelMap", newPageVariableMapData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

const pageVariableMapSlice = createSlice({
  name: "pageVariableMap",
  initialState: {
    data: null, // Stores the fetched PageVariableMap data
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null, // Stores error messages
  },
  reducers: {
    clearPageVariableMapData(state) {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchPageVariableMapData
      .addCase(fetchPageVariableMapData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchPageVariableMapData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchPageVariableMapData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handle updatePageVariableMapData
      .addCase(updatePageVariableMapData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updatePageVariableMapData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = { ...state.data, ...action.payload };
      })
      .addCase(updatePageVariableMapData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handle addPageVariableMapData
      .addCase(addPageVariableMapData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addPageVariableMapData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = [...(state.data || []), action.payload];
      })
      .addCase(addPageVariableMapData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearPageVariableMapData } = pageVariableMapSlice.actions;

export default pageVariableMapSlice.reducer;
